import { observer } from "mobx-react";
import * as React from "react";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup } from "@blueprintjs/core";
import { observable } from "mobx";
import { MDBCol, MDBRow } from "mdbreact";
import { AppStore } from "../../stores/AppStore";
import { LoginStore } from "../../stores/login/LoginStore";
import Auth2faPage from "../2fa/Auth2faPage";
import { toast } from "react-toastify";
import { GenerateStore } from "../../stores/2fa/GenerateStore";
import { LoginGeneratePage } from "../2fa/LoginGeneratePage";
import Cookies from 'universal-cookie';
import { AppIcon } from "../utils/AppIcon";

const cookies = new Cookies()

@observer
export class LoginPage extends React.Component<{}, {}> {

  obs = observable({
    email: "" as string,
    password: "" as string,
    loading: false as boolean,
    mostraSenha: false,
  })

  constructor(props) {
    super(props);
  }

  componentDidMount(): void {
    cookies.set('goto', "", { path: '/' });
    cookies.set('goto_adm', "", { path: '/' });
    cookies.set('goto_2fa', "", { path: '/' });
    cookies.set('goto_repre', "", { path: '/' });
    cookies.set('goto_socket', "", { path: '/' });
  }

  handleCreateConta() {
    AppStore.setLocation("/conta/criar");
  }

  handleRestorePassword() {
    AppStore.setLocation("/esqueci-minha-senha");
  }

  async handleAcessarSistema() {
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/

    let ipv4: string = ""

    await fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        ipv4 = data.ip;
      })
      .catch(error => ipv4 = "")

    if (this.obs.email == "") {
      toast.warning("E-mail obrigatório!", {});
      return
    }

    if (!regex.test(this.obs.email)) {
      toast.warning('E-mail inválido!', {});
      return
    }

    if (this.obs.password == "") {
      toast.warning('Senha obrigatório!', {});
      return
    }
    this.obs.loading = true

    let params = {
      email: this.obs.email,
      password: this.obs.password,
      ipv4: ipv4
    }

    let isOk: boolean = await LoginStore.handleLogin(params)

    if (isOk && !LoginStore.obs.byPass) {
      GenerateStore.obs.open2fa = true
    } else {
      let isValid = await LoginStore.handleLoginNot2fa(this.obs.email, this.obs.password)

      if (isValid) {
        GenerateStore.obs.openCadastra2fa = true
      }
    }

    this.obs.loading = false
  }

  handleClose2Fa() {
    // window.location.href = "/"

    GenerateStore.obs.openCadastra2fa = false
    GenerateStore.obs.codeBackup = []
  }

  toggleMostraSenha = () => {
    this.obs.mostraSenha = !this.obs.mostraSenha
  }

  handleSearchOnKeyEnter(e) {
    if (e.key === 'Enter') {
      this.handleAcessarSistema()
    }
  }

  render() {

    const lockButton = (
      <Button
        icon={this.obs.mostraSenha ? <AppIcon name="visibility_off" color="#526f74" /> : <AppIcon name="visibility" color="#526f74" />}
        onClick={this.toggleMostraSenha}
        className="btn-eyes"
      />
    );

    return (
      <>

        <Dialog
          isOpen={GenerateStore.obs.openCadastra2fa}
          onClose={() => this.handleClose2Fa()}
          className="modal-two-factor">

          <div className={Classes.DIALOG_CLOSE_BUTTON}>

            <AppIcon name="close" color="#000" style={{ float: "right", cursor: "pointer" }} onClick={() => this.handleClose2Fa()} />

          </div>

          <LoginGeneratePage />

        </Dialog>

        {GenerateStore.obs.open2fa ?

          <Auth2faPage email={this.obs.email} password={this.obs.password} token="" />

          :

          <div className="container-fluid container-login">
            <MDBRow>
              <MDBCol md="6" className="form-login" style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
                <div className="login-img">
                  <img src="/images/logo-novo.png" className="img-responsive" />
                </div>

                <h3 className="title-login" style={{ textAlign: "center" }}>Acesso ao Sistema</h3>

                <FormGroup
                  className="form-group"
                  label="E-mail">
                  <InputGroup type="text" onChange={(e: any) => this.obs.email = e.target.value} placeholder="email@email.com" className="input-email" onKeyPress={this.handleSearchOnKeyEnter.bind(this)} />
                </FormGroup>

                <FormGroup
                  className="form-group"
                  label="Senha">
                  <InputGroup
                    rightElement={lockButton}
                    type={this.obs.mostraSenha ? "text" : "password"}
                    value={this.obs.password}
                    onChange={(e: any) => this.obs.password = e.target.value}
                    placeholder="***********"
                    className="input-senha"
                    onKeyPress={this.handleSearchOnKeyEnter.bind(this)}
                  />
                  <div style={{ textAlign: "right" }}>
                    <label style={{ fontSize: "12px", fontWeight: 600, cursor: "pointer" }} onClick={() => this.handleRestorePassword()}>Esqueci minha senha</label>
                  </div>
                </FormGroup>

                <div className="actions-form">
                  {!this.obs.loading
                    ? <Button className="btn btn-login" onClick={() => this.handleAcessarSistema()} onKeyPress={this.handleSearchOnKeyEnter.bind(this)}>Acessar</Button>
                    : <Button className="btn btn-login">
                      <i className="fa fa-spinner fa-spin"></i>
                      Acessando
                    </Button>
                  }
                </div>

                <div className="login-footer-login" style={{ marginBottom: 20 }}>
                  <div style={{ textAlign: "center" }}>
                    Não tem conta ainda? <label style={{ cursor: "pointer" }} onClick={() => this.handleCreateConta()}><b style={{ color: "#3579EA" }}>Crie agora</b></label>
                  </div>
                </div>

                <div style={{ textAlign: "center", fontSize: 15, marginTop: "auto", marginBottom: 20 }}>
                  <div className="name-ent">Gerenciador Fiscal e Tributário Ltda.</div>
                  <div>© 2023 . Todos os Direitos Reservados.</div>
                </div>

              </MDBCol>

              <MDBCol md="6" className="fundo-login">
                <div className="fundo-bg"></div>
              </MDBCol>
            </MDBRow>

          </div>
        }
      </>
    );
  }
}

export default LoginPage;
